// src/request/api/dict/getAllTraits.ts

import {ApiRequest, RequestMethod} from "../../../request";

const URL = "/api/weapon-trait";

export type GetAllTraitsResult = {
    id: string;
    name: string;
    description: string;
    commonStatus: number;
}[];

export async function getAllTraits(): Promise<GetAllTraitsResult> {
    const apiRequest = new ApiRequest();
    apiRequest.setMethod(RequestMethod.GET);
    apiRequest.setUrl(URL);

    const response: any = await apiRequest.send();

    return response.data.map((trait: any) => ({
        id: trait["id"],
        name: trait["name"],
        description: trait["description"],
        commonStatus: trait["commonStatus"],
    }));
}